import './new-person-address.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreatePersonAddress } from "@core/query/person-address.query";
import { PersonAddressFormRule, PersonAddressFormSchema } from "@core/form/form.rule";
import { personAddressFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormPersonAddress from "../form-person-address/form-person-address";

export function PersonAddress() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreatePersonAddress } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New PersonAddress is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addPersonAddress, isLoading: isCreating } =
    useQyCreatePersonAddress(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<PersonAddressFormSchema>({
    defaultValues: personAddressFormDefault,
    resolver: zodResolver(PersonAddressFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: PersonAddressFormSchema) => {
    const formData = mapCreatePersonAddress(form);
    addPersonAddress(formData);
  };
  const handleValidateError = (err: FieldErrors<PersonAddressFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="PersonAddress" className="person-address">
      <HeaderContent
        title="New PersonAddress"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormPersonAddress />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default PersonAddress;